import { useBookingStore } from '../store/bookingStore';
import { useNavigation } from './useNavigation';
import { SearchParams, Booking, PassengerInfo } from '../models/Booking';

/**
 * Hook personalizado para el flujo de reserva
 * Similar a un BookingService en Angular
 * 
 * Maneja toda la lógica del proceso de reserva
 */
export const useBooking = () => {
  const { 
    searchParams, 
    selectedBooking, 
    passengerData,
    setSearchParams,
    setSelectedBooking,
    setPassengerData,
    clearBooking,
  } = useBookingStore();

  const { goToSearch, goToPassengers, goToPayment, goToTicket } = useNavigation();

  /**
   * Inicia una búsqueda de rutas
   */
  const startSearch = (params: SearchParams) => {
    setSearchParams(params);
    goToSearch();
  };

  /**
   * Selecciona asientos y continúa a formulario de pasajeros
   */
  const selectSeats = (booking: Booking, seats: string[]) => {
    setSelectedBooking(booking, seats);
    goToPassengers();
  };

  /**
   * Guarda datos de pasajeros y continúa a pago
   */
  const continueToPayment = (passengers: PassengerInfo[]) => {
    setPassengerData(passengers);
    goToPayment();
  };

  /**
   * Completa la reserva y va al ticket
   */
  const completeBooking = () => {
    goToTicket();
  };

  /**
   * Resetea todo el flujo de reserva
   */
  const resetBooking = () => {
    clearBooking();
  };

  return {
    // Estado
    searchParams,
    selectedBooking,
    passengerData,
    
    // Acciones
    startSearch,
    selectSeats,
    continueToPayment,
    completeBooking,
    resetBooking,
  };
};
